<template>
    <component :is="component" :course="course"></component>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            course: {},
        }
    },

    props: {
        access: {
            type: String
        },
        courseCode: {
            type: String
        }
    },

    created () {
       this.fetchCourse()
    },

    computed: {
        ...mapGetters({
            userDetail: 'auth/userDetail',
        }),

        component() {
            if(this.course.id) {
                return () => import(`@/modules/credentialCourse/views/${this.courseCode}/index`)
            }
        },

        mhaMember () {
            return this.userDetail('profile')
        },

        activeMhaMember () {
            return this.mhaMember && this.mhaMember.status === 'active'
        }
    },

    methods: {
        fetchCourse () {
            return axios.get(`/api/v1/credential/courses/${this.courseCode}?include=testimonials,promo`)
                .then(({ data }) => {
                    this.course = data
                }).catch((error) => {
                    this.$router.replace('/')
                })
        },
    },

    beforeRouteEnter (to, from, next) {
        const access = _.get(to, 'params.access')
        if (['members', 'enrol'].indexOf(access) <= -1) {
            next(`/credential/${to.params.courseCode}/enrol`)
        }

        next(vm => {
            if (vm.activeMhaMember) {
                next(`/credential/${to.params.courseCode}/members`)
            } else {
                next(`/credential/${to.params.courseCode}/enrol`)
            }
        })
    }
}
</script>
